export default "__VITE_ASSET__CObY7syT__"